import React from "react";
// import Header from "./components/Header";
import Home from "./components/Home";
import "./styles/App.css";

const App = () => {
  return (
    <>
      <Home />
    </>
  );
};

export default App;
